"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionTallBannerSwipeWidgetDataSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var PromotionTallBannerSwipeWidgetHeaderSchema = zod_1.z.object({
    title: zod_1.z.string().optional(),
    icon: zod_1.z.string().optional(),
    subTitle: zod_1.z.string().optional(),
    more: zod_1.z
        .object({
        title: zod_1.z.string(),
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
    })
        .optional(),
});
var PromotionTallBannerSwipeItemSchema = zod_1.z.object({
    alt: zod_1.z.string(),
    image: zod_1.z.object({
        url: zod_1.z.string(),
        width: zod_1.z.number(),
        height: zod_1.z.number(),
    }),
    action: common_1.CommonResponseItemActionDto,
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
/**
 * [V2] 프로모션 세로형 배너 스와이프 - 응답 스키마 (YDM__NOL_PROMOTION_TALL_BANNER_SWIPE__V2, v9.15.0~)
 *
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-display-api#tag/Banner/paths/~1banner~1v3~1promotion-tall-swipe/get}
 */
exports.PromotionTallBannerSwipeWidgetDataSchema = zod_1.z.object({
    header: PromotionTallBannerSwipeWidgetHeaderSchema,
    rollingInterval: zod_1.z.number(),
    items: zod_1.z.array(PromotionTallBannerSwipeItemSchema),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
